export default [
  {
    path: '/sobre/',
    name: 'sobre',
    title: 'sobre',
    component: () => import('../views/VersionAboutView.vue'),
  },
];
